import { render, staticRenderFns } from "./DocumentCabinet.vue?vue&type=template&id=150e6a18&"
import script from "./DocumentCabinet.vue?vue&type=script&lang=js&"
export * from "./DocumentCabinet.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports